
<div class="modal" id='precosPracaPedagio' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  style="z-index: 9999;" aria-hidden="true" data-keyboard="false">
  
  <div class="modal-dialog ">
    <div class="modal-content modal-w">

      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Pedágio - {{ praca }}</h5>
        <img id="idBtFecharConfiguracoes" data-bs-dismiss="modal" class='bt-fechar'
          src="assets/img/icon_bt-limpar_header.svg">
      </div>

      <button hidden=true (click)="atualizarDados()" id="btnAtualizarDados"></button>
      <div class="modal-body"> 
        <div class='col'>
    
          <p class="mb-0 pedagio-titulo">{{ concesssionaria }} | {{ rodovia }}- km {{ km }}</p>
          <div class="d-flex justify-content-between align-items-baseline">
            <div>
              <p class="pedagio-sub-titulo" ><span class="me-3" [ngStyle]="{ 'display': displayFreeFlow }">Free flow</span>  <span [ngStyle]="{ 'display': displayAceitaTag }"  >Desc. Sem Parar: {{ porcTagDesconto }}%</span></p>
            </div>
            <div>
              <p class="pedagio-oc mb-0" [ngStyle]="{ 'display': displayOcAbertaAviso }" ><i class="fa fa-info-circle "></i> Novos valores em análise</p>
            </div>
          </div> 
  
            <div class="d-flex justify-content-center" *ngIf="!loading else loadingDados" >
              <div class="table-wrapper overflow-auto">
                <table class="table table-sm custom-table">
                  <thead>
                    <tr>
                      <th class="pedagio-info-destaque"></th>
                      <th class="pedagio-info-destaque">Tipo de veículo</th>
                      <th class="pedagio-info-destaque">Qtd. eixo</th>
                      <th class="pedagio-info-destaque">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr [ngClass]="{'destacaVeic':item.CodCategoriaPedagio == this.veiculoDestaqueID}"*ngFor="let item of pracasPrecos">
                      <td [innerHTML]="getIcone(item.CodCategoriaPedagio)" style="text-align: center;"></td>
                      <td> {{ item.tipoVeiculo }} </td>
                      <td> {{ item.QuantidadeEixo }} </td>
                      <td> <span class="pedagio-cifrao">R$</span> {{ item.Valor | number:'1.2-2' }} </td>             
                    </tr>
                    
                  </tbody>                
                </table>
              </div>  
            </div>
            <ng-template #loadingDados>
              <div id='loading-precos' *ngIf="loading" >
                <img src='assets/img/loading.gif' class="size-img-loading"> Carregando informações... 
              </div>    
             </ng-template>
            <p class="valor-atualizado ms-custom-valores mt-2 mb-1" *ngIf="dataAtualizacao != null" >
              Valores atualizados em {{ dataAtualizacao | date: 'dd/MM/yyyy'}}
            </p>   
        </div>
      </div>

   
    </div>
  </div>
</div>
